import React from "react";

/**
 * @component CompanyAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CompanyAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CompanyAddIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={18}
      height={20}
      viewBox="0 0 18 20"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CompanyAddIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0v2H2v16h5v-3.5h2V18h5V8h2v12H0V2a2 2 0 012-2h8zm3 14v2h-2v-2h2zm-8 0v2H3v-2h2zm8-5v2h-2V9h2zM9 9v2H7V9h2zM5 9v2H3V9h2zm4-5v2H7V4h2zM5 4v2H3V4h2zm11-4v2h2v2h-2v2h-2V3.999L12 4V2l2-.001V0h2z"
      />
    </svg>
  )
);
CompanyAddIcon.displayName = "CompanyAddIcon";
export default CompanyAddIcon;
